var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 1.5C10.2304 1.5 1.5 10.2304 1.5 21C1.5 31.7696 10.2304 40.5 21 40.5C31.7696 40.5 40.5 31.7696 40.5 21C40.5 10.2304 31.7696 1.5 21 1.5ZM0.5 21C0.5 9.67816 9.67816 0.5 21 0.5C32.3218 0.5 41.5 9.67816 41.5 21C41.5 32.3218 32.3218 41.5 21 41.5C9.67816 41.5 0.5 32.3218 0.5 21Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3438 28V20.9992H24.2763L24.5324 18.5867H22.3438L22.347 17.3792C22.347 16.7499 22.4068 16.4128 23.3106 16.4128H24.5187V14H22.5859C20.2643 14 19.4471 15.1703 19.4471 17.1385V18.5869H18V20.9995H19.4471V28H22.3438Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.550490e36eb88832900a886c94988a47.svg";